/* ── SmartPack Core — Pricing engine → window.SPPricing ── */
(function () {
  'use strict';
  if (window.SPPricing) return;

  var ONCE_STEP = 50,  ONCE_MIN = 50;
  var SUB_STEP  = 500, SUB_MIN  = 500;

  var FEE = { '6mo': 1.05, 'qtr': 1.07, '2mo': 1.08, 'mon': 1.09, '2wk': 1.10 };

  var PER_YEAR_FALLBACK = {
    '703437373753': 26, '703437340985': 12, '703437406521': 6,
    '703437439289': 4,  '703437472057': 2
  };

  function planIds() {
    if (window.SPBlanket && window.SPBlanket.PLANS) return Object.keys(window.SPBlanket.PLANS);
    return Object.keys(PER_YEAR_FALLBACK);
  }

  function perYear(planId) {
    var id = String(planId);
    if (window.SPBlanket && window.SPBlanket.PLANS && window.SPBlanket.PLANS[id]) {
      return window.SPBlanket.PLANS[id].perYear;
    }
    return PER_YEAR_FALLBACK[id] || 0;
  }

  function money(c) {
    return '$' + (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function num(n) { return n.toLocaleString('en-US'); }

  function blanketCents(baseCents, freqKeys) {
    if (!baseCents || !freqKeys || !freqKeys.length) return null;
    var exact = freqKeys.map(function (f) { return baseCents * FEE[f]; });
    if (exact.some(isNaN)) return null;
    var lo = Math.round(Math.min.apply(null, exact));
    var hi = Math.round(Math.max.apply(null, exact));
    var opts = [lo - 1, lo, hi, hi + 1].filter(function (c, i, a) { return c > 0 && a.indexOf(c) === i; });
    var best = null, bestErr = Infinity;
    opts.forEach(function (c) {
      var err = Math.max.apply(null, exact.map(function (e) { return Math.abs(c - e) / e; }));
      if (err < bestErr - 1e-12) { bestErr = err; best = c; }
    });
    return best;
  }

  function blanketBandFor(data, annual) {
    var list = (data && data.blanketBands) || [];
    var found = null;
    for (var i = 0; i < list.length; i++) if (annual >= list[i].min) found = list[i];
    return found;
  }

  function blanketUnitFor(data, qtyPerRelease, planId) {
    if (!window.SPBlanket || !qtyPerRelease || !planId) return null;
    var key = window.SPBlanket.spBandValue(qtyPerRelease, planId, data);
    if (!key) return null;
    var bb = blanketBandFor(data, qtyPerRelease * perYear(planId));
    return bb ? blanketCents(bb.cents, key.split('|')[1].split('-')) : null;
  }

  function bestBlanketFor(data, qtyPerRelease) {
    var best = null;
    planIds().forEach(function (pid) {
      var c = blanketUnitFor(data, qtyPerRelease, pid);
      if (c !== null && (best === null || c < best)) best = c;
    });
    return best;
  }

  function bestBlanketPlanFor(data, qtyPerRelease) {
    var best = null, bestPid = '';
    planIds().forEach(function (pid) {
      var c = blanketUnitFor(data, qtyPerRelease, pid);
      if (c !== null && (best === null || c < best)) { best = c; bestPid = pid; }
    });
    return { cents: best, planId: bestPid };
  }

  var _floor = (typeof WeakMap === 'function') ? new WeakMap() : null;
  function lowestBlanket(data) {
    if (!data) return null;
    if (_floor && _floor.has(data)) return _floor.get(data);
    var bb = data.blanketBands;
    var v = null;
    if (bb && bb.length) {
      var deepest = bb[bb.length - 1].min;
      planIds().forEach(function (pid) {
        var py = perYear(pid);
        if (!py) return;
        var q = Math.max(SUB_MIN, Math.ceil(Math.ceil(deepest / py) / SUB_STEP) * SUB_STEP);
        var c = blanketUnitFor(data, q, pid);
        if (c !== null && (v === null || c < v)) v = c;
      });
    }
    if (v === null && !window.SPBlanket) return null;
    if (_floor) _floor.set(data, v);
    return v;
  }

  function onceLadder(data) {
    var bands = (data && data.bands) || [];
    var tiers = bands.map(function (b) { return { min: b.min, cents: b.cents }; });
    if (data && data.list && tiers.length && tiers[0].min > ONCE_MIN) {
      tiers.unshift({ min: ONCE_MIN, cents: data.list });
    }
    return tiers;
  }

  function blanketLadder(data, planId) {
    if (!planId || !window.SPBlanket) return [];
    var py = perYear(planId);
    if (!py) return [];
    var src = (data && data.blanketBands) || [];
    var cands = [SUB_MIN];
    src.forEach(function (b) {
      var q = Math.ceil(b.min / py);
      cands.push(Math.max(SUB_MIN, Math.ceil(q / SUB_STEP) * SUB_STEP));
    });
    cands = cands.filter(function (v, i, a) { return a.indexOf(v) === i; })
                 .sort(function (a, b) { return a - b; });
    var rows = [];
    cands.forEach(function (q) {
      var c = blanketUnitFor(data, q, planId);
      if (c === null) return;
      var last = rows[rows.length - 1];
      if (last && last.cents === c) return;
      rows.push({ min: q, cents: c });
    });
    return rows;
  }

  function selectedIndex(tiers, qty) {
    var s = 0;
    for (var i = 0; i < tiers.length; i++) if (qty >= tiers[i].min) s = i;
    return s;
  }

  function tierLabel(tiers, i, cap) {
    var next = tiers[i + 1];
    if (next) return num(tiers[i].min) + ' – ' + num(next.min - 1);
    if (cap) return num(tiers[i].min) + ' – ' + num(cap);
    return num(tiers[i].min) + '+';
  }

  function snapOnce(q) { return Math.max(ONCE_MIN, Math.round(q / ONCE_STEP) * ONCE_STEP); }
  function snapSub(q)  { return Math.max(SUB_MIN,  Math.round(q / SUB_STEP)  * SUB_STEP);  }

  window.SPPricing = {
    ONCE_MIN: ONCE_MIN, ONCE_STEP: ONCE_STEP,
    SUB_MIN: SUB_MIN,   SUB_STEP: SUB_STEP,
    FEE: FEE,
    planIds: planIds,
    perYear: perYear,
    money: money,
    num: num,
    blanketCents: blanketCents,
    blanketBandFor: blanketBandFor,
    blanketUnitFor: blanketUnitFor,
    bestBlanketFor: bestBlanketFor,
    bestBlanketPlanFor: bestBlanketPlanFor,
    lowestBlanket: lowestBlanket,
    onceLadder: onceLadder,
    blanketLadder: blanketLadder,
    selectedIndex: selectedIndex,
    tierLabel: tierLabel,
    snapOnce: snapOnce,
    snapSub: snapSub
  };
})();
